<template>
  <div class="modalUser">
    <b-modal id="modalFileDelete" ref="modalFileDelete" modal-class="modal-no-border modal-rename modal-radius top-mb" centered no-close-on-backdrop>
    <template v-slot:modal-header="{ close }">
        <!-- Emulate built in modal header close button action -->
        <div class="title-modal text-center w-100">
          <div class="btn-closeModal" @click="close()">
            <svg height="329pt" viewBox="0 0 329.26933 329" width="329pt" xmlns="http://www.w3.org/2000/svg"><path d="m194.800781 164.769531 128.210938-128.214843c8.34375-8.339844 8.34375-21.824219 0-30.164063-8.339844-8.339844-21.824219-8.339844-30.164063 0l-128.214844 128.214844-128.210937-128.214844c-8.34375-8.339844-21.824219-8.339844-30.164063 0-8.34375 8.339844-8.34375 21.824219 0 30.164063l128.210938 128.214843-128.210938 128.214844c-8.34375 8.339844-8.34375 21.824219 0 30.164063 4.15625 4.160156 9.621094 6.25 15.082032 6.25 5.460937 0 10.921875-2.089844 15.082031-6.25l128.210937-128.214844 128.214844 128.214844c4.160156 4.160156 9.621094 6.25 15.082032 6.25 5.460937 0 10.921874-2.089844 15.082031-6.25 8.34375-8.339844 8.34375-21.824219 0-30.164063zm0 0"/></svg>
          </div>
        </div>
      </template>
      <div class="modalUser--main files">
        <h2 class="title text-center">削除</h2>
        <p class="sub-title text-center">このファイルを削除してもよろしいでしょうか</p>
        <div class="text-center">
          <div class="folder">
            <img :src="detailFile.icon_url" class="img-folder img-deleteModal" />
            <div class="img-typeD" v-if="isVideo(detailFile.media_type_id)"><img src="@img/icon/icon-video.svg" /></div>
            <div class="img-typeD" v-if="isImage(detailFile.media_type_id)"><img src="@img/icon/icon-image.svg" /></div>
          </div>
          <p class="sub-title text-center folder-descript">{{truncate(detailFile.name,15,'...')}}</p>
        </div>
      </div>
      <template v-slot:modal-footer>
        <div class="w-100 button-group">
          <button
            class="btn btn-rounder btn-danger btn-login btn-primary w-100 mw-253"
            type="button" @click="deleteFile">削除</button>
        </div>
        <div class="btn-group-2">
          <button
          class="btn btn-rounder btn-second btn-cancel w-100 mw-253"
          type="button" @click="closeModalDelete">キャンセル</button>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { BModal, VBModal } from 'bootstrap-vue'
import {mapState} from 'vuex'
import {MEDIA_TYPE} from '../../../utils/constant'
export default {
  name: 'FileDelete',
  components: {
    'b-modal': BModal
  },
  directives: {
    // Note that Vue automatically prefixes directive names with `v-`
    'b-modal': VBModal
  },
  data () {
    return {
      modalShow: false
    }
  },
  methods: {
    closeModalDelete () {
      this.$store.commit('adminFolder/CHANGE_DETAIL_FOLDER', '')
      this.$refs['modalFileDelete'].hide()
    },
    isImage (value) {
      return value === MEDIA_TYPE.IMAGE_ROLE_ID
    },
    isVideo (value) {
      return value === MEDIA_TYPE.VIDEO_ROLE_ID
    },
    back () {
      this.$emit('pageIndexBack')
    },
    loadFile () {
      this.reloadFileAdmin(1)
    },
    deleteFile () {
      if (this.$route.params.file_id) {
        const folderParent = (this.$route.query.parent === 'search') ? 0 : this.$route.query.parent
        if (this.$route.query.tab) {
          this.$store.dispatch('adminFolder/deleteFile', {id: this.detailFile.id,
            folder_parent: folderParent,
            company_id: this.$route.params.id,
            modal: this.$refs['modalFileDelete'],
            tab: this.$route.query.tab})
        } else {
          this.$store.dispatch('adminFolder/deleteFile', {id: this.detailFile.id,
            company_id: this.$route.params.id,
            modal: this.$refs['modalFileDelete'],
            folder_parent: folderParent})
        }
      } else {
        this.$store.dispatch('adminFolder/deleteFile', {id: this.detailFile.id,
          company_id: this.$route.params.id,
          back: this.back,
          load: this.loadFile,
          modal: this.$refs['modalFileDelete']})
      }
    }
  },
  computed: {
    ...mapState({
      detailFile: state => state.adminFolder.detailFile
    })
  }
}
</script>
<style scoped lang="scss">
@import "@/assets/stylesheet/auth/listfile.scss";
.mr-30{
  margin-right: 30px;
}
.mw-253{
  max-width: 253px;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/FolderManagerment/FileDelete.vue